import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from '../../api.service';
import {VPC} from './vpc.model';

@Injectable({
  providedIn: 'root'
})
export class VpcsService {

  constructor(
    private readonly apiService: ApiService
  ) {
  }

  public getAll(): Observable<VPC[]> {
    return this.apiService.get<VPC[]>('/account/vpcs');
  }
}
